import styled, { useTheme } from "styled-components";

import { rotateAnimation } from "@sso/theme/animations";

import { Wrapper } from "./FlexBox";

interface CircleLoadingProps {
  color?: string;
  size?: number;
  borderSize?: number;
  blurBackground?: boolean;
  bgColor?: string;
  zIndex?: number;
  top?: string;
  bottom?: string;
}

const RotateLoading = styled.div<CircleLoadingProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  inset: 0;
  z-index: ${p => p.zIndex || p.theme.zIndex.modal};
  ${p => p.top && `top: ${p.top}`};
  ${p => p.bottom && `bottom: ${p.bottom}`};
  div {
    position: absolute;
    border-radius: 50%;

    width: ${p => (p.size ? p.size * 6 : 30)}px;
    height: ${p => (p.size ? p.size * 6 : 30)}px;

    border: ${p => p.borderSize || p.size || 5}px solid transparent;
    animation: ${rotateAnimation} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${p => p.color || p.theme.colors.primary.main} transparent transparent transparent;
  }
  div:nth-child(1) {
    animation-delay: -0.45s;
  }
  div:nth-child(2) {
    animation-delay: -0.3s;
  }
  div:nth-child(3) {
    animation-delay: -0.15s;
  }
`;

export const CircleLoading = ({ blurBackground, bgColor, ...props }: CircleLoadingProps) => {
  const theme = useTheme();
  return (
    <>
      {blurBackground && (
        <Wrapper
          zIndex={theme.zIndex.modal}
          inset="0"
          position="absolute"
          background={bgColor || theme.colors.background.paper}
          opacity={0.7}
        />
      )}
      <RotateLoading {...props}>
        {Array.from({ length: 4 }, (_, i) => (
          <div key={i} />
        ))}
      </RotateLoading>
    </>
  );
};
